import { Modal, Input, Button, Select } from 'antd'
import React, { useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { CloseOutlined } from '@ant-design/icons'
import { http } from '@services/http'
import SuccessModal from './SuccessModal'
import ErrorModal from './ErrorModal'
import ConfirmDeleteModal from './ConfirmDeleteModal'

const IgnoreSaleModal = ({ visible, data, onClose }) => {
	const { t } = useTranslation()
	const successRef = useRef()
	const errorRef = useRef()

	const [loading, setLoading] = useState(false)
	const [comment, setComment] = useState('')
	const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false)

	const patchData = async () => {
		setLoading(true)
		setIsConfirmModalVisible(false)
		try {
			await http.patch(
				`api/sales/ignore-cancel-request/${data?.docEntry}?comment=${comment}`,
			)
			successRef.current.open(t('sucCreated'))
			onClose()
			setComment('')
		} catch (error) {
			errorRef.current.open(error?.response?.data?.message)
		} finally {
			setLoading(false)
		}
	}

	if (!data) return null

	return (
		<Modal
			title={
				<h1 className="font-nunito  font-extrabold text-[#000000]">
					{t('ignoreCancel')}
				</h1>
			}
			open={visible}
			onCancel={onClose}
			footer={null}
			closeIcon={<CloseOutlined />}
			width="50%"
			style={{ height: '70%' }}
		>
			<div className="w-full px-2 sm:px-14">
				<div className="flex flex-col items-center gap-10 sm:flex-row">
					<div className="mt-4 flex flex-col gap-3 sm:mt-5 w-full">
						<p>{t('comments')}</p>
						<Input.TextArea
							type="text"
							value={comment}
							onChange={(e) => {
								setComment(e.target.value)
							}}
							className="flex h-10 w-full  items-center justify-center border-[1px] border-[#D0D0D0]"
						/>
					</div>
				</div>
				<div className="flex items-center gap-10 mt-14 justify-between">
					<Button
						type="danger"
						onClick={() => {
							onClose()
						}}
						className="w-full bg-red-500 hover:bg-red-300 bg h-[35px] rounded-lg text-white"
					>
						{t('exit')}
					</Button>
					<Button
						type="danger"
						onClick={() => {
							setIsConfirmModalVisible(true)
						}}
						loading={loading}
						disabled={loading || !comment}
						className="w-full bg-red-700 h-[35px] rounded-lg hover:bg-red-500 text-white disabled:bg-red-300"
					>
						{t('ignoreCancel')}
					</Button>
				</div>
			</div>
			<SuccessModal
				getRef={(r) => {
					successRef.current = r
				}}
			/>
			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
			/>
			<ConfirmDeleteModal
				title={t('sureIgnore')}
				visible={isConfirmModalVisible}
				handleClickCancel={() => {
					setIsConfirmModalVisible(false)
					setTimeout(() => {
						onClose()
					}, 500)
				}}
				handleClickNo={() => {
					setIsConfirmModalVisible(false)
					setTimeout(() => {
						onClose()
					}, 500)
				}}
				handleClickYes={patchData}
			/>
		</Modal>
	)
}

export default IgnoreSaleModal
